export type DefaultError = {
  name: string;
  status: number;
  message: string;
  stack: string;
};

declare module '@tanstack/react-query' {
  interface Register {
    defaultError: DefaultError;
  }
}

export class CustomError extends Error {
  status = 500;

  constructor(message: string, status: number = 500, name: string = 'CustomError') {
    super(message);
    this.name = name;
    this.status = status;
  }
}

export async function handleServerResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    let errorMessage = 'Something went wrong';
    let errorStatus = response.status;
    let errorName = 'ServerError';

    try {
      const body = await response.json();
      errorMessage = body?.error?.message || body?.message || errorMessage;
      errorStatus = body?.error?.status || errorStatus;
      errorName = body?.error?.name || errorName;
    } catch {
      // If JSON parsing fails, use default error message
      errorMessage = `${response.status} ${response.statusText}`;
    }

    console.error(errorName, errorStatus, errorMessage);
    throw new CustomError(errorMessage, errorStatus, errorName);
  }

  return response.json();
}
